var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { TagsSearchModalContainer, TagsSearchModalWrapper, ProductTagsSearchTitle, CardsWrapper, CardsEmptyTitle, CardsEmptySubTitle, CardsEmptyButtonWrapper, CardsEmptyButtonHollow, CardsEmptyButtonFilled, ModalButton, ModalText, RingWrapper, SelectRing } from './styles';
import urlApi from '../../../actions/urlApi';
import { API } from '@brg/api';
import queryString from 'query-string';
import { useProfile } from '@brg/auth';
import LangContext from '../../../contexts/Language/LangContext';
import { modalControllerActions } from '../../../core/modules/modal.module';
import { useDispatch } from 'react-redux';
import { getGalllleryUrl } from '../../../actions/getGalllleryUrl';
import { ShopCard } from '../../ShopCard/ShopCard';
import { Colors, FlexBox } from '@brg/ui';
import AspectRatio from '../../AspectRatio';
import useLocalization from '../../../hooks/useLocalization';
import { ProjectSearchBarSorting } from '../../projectsSearchBar/components/projectSearchBarSorting';
import { Pagination } from "../../pagination";
import { NoProjectWrapper } from "../CardSelectModal/styles";
export var debounceEvent = function (callback, time) {
    var interval;
    // @ts-ignore
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(interval);
        interval = setTimeout(function () {
            interval = null;
            // eslint-disable-next-line standard/no-callback-literal
            callback.apply(void 0, args);
        }, time);
    };
};
export var useProductsCards = function (queryString, disabled) {
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (queryString && !disabled) {
            setLoading(true);
            urlApi()
                .getUserProducts(queryString)
                .then(function (r) {
                setData(r);
            })
                .finally(function () { return setLoading(false); });
        }
    }, [queryString, disabled]);
    return { data: data, loading: loading };
};
var ProductsSelectModal = function (_a) {
    var _b, _c, _d, _e;
    var onSubmit = _a.onSubmit, cardIds = _a.cardIds, teamId = _a.teamId;
    var language = useLocalization().language;
    var cardsRef = useRef(null);
    var _f = useState(cardIds), selectedCards = _f[0], setSelectedCards = _f[1];
    var _g = useState(1), sorting = _g[0], setSorting = _g[1];
    var profile = useProfile();
    var dispatch = useDispatch();
    // @ts-ignore
    var t = useContext(LangContext).t;
    var buttonDisabled = !(selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) || (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) > 4;
    var _h = useState(1), currentPage = _h[0], setPage = _h[1];
    var scrollRef = useRef(null);
    var scrollTop = function () {
        var _a;
        if (!scrollRef.current)
            return;
        (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    };
    var onClick = useCallback(function (cardId, selected) {
        if (selected) {
            setSelectedCards(selectedCards.filter(function (item) { return item !== cardId; }));
            return;
        }
        setSelectedCards(__spreadArray(__spreadArray([], selectedCards, true), [cardId], false));
    }, [selectedCards]);
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify({
            cardOnlyImage: true,
            status: [2],
            userIds: (profile && !teamId) ? [profile === null || profile === void 0 ? void 0 : profile.accountId] : [],
            teamId: teamId,
            isHeaderIgnored: true,
            isLite: 'true',
            sort: sorting,
            page: currentPage,
            limit: 16
        });
    }, [sorting, teamId, profile, currentPage]);
    var _j = useProductsCards(cardsQueryString), data = _j.data, loading = _j.loading;
    // @ts-ignore
    var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, language);
    var handleAttachClick = function () {
        if (!buttonDisabled) {
            onSubmit(selectedCards);
        }
    };
    if (!loading && (cards === null || cards === void 0 ? void 0 : cards.length) === 0)
        return (React.createElement(TagsSearchModalWrapper, { scroll: true, isWhite: true },
            React.createElement(TagsSearchModalContainer, { isCenterModal: true },
                React.createElement(CardsEmptyTitle, null, t('modal.select_card_modal.no_cards')),
                React.createElement(CardsEmptySubTitle, null, t('modal.select_card_modal.no_cards_desc')),
                React.createElement(CardsEmptyButtonWrapper, null,
                    React.createElement(CardsEmptyButtonHollow, { onClick: function () { return dispatch(modalControllerActions.hideModal({})); } }, t('modal.select_card_modal.continue_edit')),
                    React.createElement(CardsEmptyButtonFilled, { onClick: function () { return window.open(getGalllleryUrl(), '_blank'); } }, t('modal.select_card_modal.go_to_gallllery'))))));
    return (React.createElement(TagsSearchModalWrapper, { autoScroll: true },
        React.createElement(TagsSearchModalContainer, null,
            React.createElement(FlexBox, { justify: 'space-between', align: 'center', offsetBottom: 48 },
                React.createElement(ProductTagsSearchTitle, null, t('modal.select_card_modal.select_cards')),
                React.createElement(ModalButton, { onClick: handleAttachClick, fill: Colors.galBlack100, disabled: buttonDisabled }, t('modal.select_card_modal.attach'))),
            React.createElement(FlexBox, { justify: 'space-between', offsetBottom: 32 },
                React.createElement(FlexBox, { align: 'center', gx: 24 },
                    React.createElement(ModalText, null, t('modal.select_card_modal.cards')),
                    React.createElement(ModalText, { color: Colors.galBlack47 },
                        t('modal.select_card_modal.selected_cards'),
                        ":",
                        ' ',
                        (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) > 4 ? (React.createElement("span", { style: { color: 'red' } }, selectedCards === null || selectedCards === void 0 ? void 0 :
                            selectedCards.length,
                            "/4")) : (React.createElement("span", null, selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length)))),
                React.createElement(ProjectSearchBarSorting, { selectedSorting: sorting, onSortingChange: setSorting, sortingMethods: [1, 2] })),
            (cards === null || cards === void 0 ? void 0 : cards.length) > 0 ? (React.createElement(React.Fragment, null,
                React.createElement(CardsWrapper, { ref: cardsRef }, !!data &&
                    (
                    /* @ts-ignore */
                    cards === null || cards === void 0 ? void 0 : cards.map(function (value) {
                        var selected = selectedCards.includes(value === null || value === void 0 ? void 0 : value.entityId);
                        return (
                        // @ts-ignore
                        React.createElement(AspectRatio, { key: value === null || value === void 0 ? void 0 : value.entityId, ratio: 111 / 148 },
                            React.createElement(ShopCard, { useTemplateCard: true, isSmall: true, isModal: true, customClick: function () { return onClick(value === null || value === void 0 ? void 0 : value.entityId, selected); }, selected: selected, key: value === null || value === void 0 ? void 0 : value.entityId, card: value, hideDescription: true, selectedComponent: React.createElement(RingWrapper, { className: 'selected-component', onClick: function () { return onClick(value === null || value === void 0 ? void 0 : value.entityId, selected); } },
                                    React.createElement(SelectRing, { active: selected }, selected && (React.createElement("div", null,
                                        React.createElement("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                            React.createElement("path", { d: "M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966\n                                                  4.02557L1 4.85653Z", fill: "#151514", stroke: "#151514" })))))) })));
                    }))),
                React.createElement("div", { style: { marginTop: 50 } },
                    React.createElement(Pagination
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        pages: (_c = (_b = data === null || data === void 0 ? void 0 : data.paging) === null || _b === void 0 ? void 0 : _b.pages) !== null && _c !== void 0 ? _c : 0, page: Number(currentPage), onPageChange: function (page) {
                            // @ts-ignore
                            setPage(page);
                            scrollTop();
                        }, 
                        // @ts-ignore
                        isCanLoadMore: currentPage < ((_e = (_d = data === null || data === void 0 ? void 0 : data.paging) === null || _d === void 0 ? void 0 : _d.pages) !== null && _e !== void 0 ? _e : 0) })))) : (React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :(")))));
};
export default ProductsSelectModal;
//# sourceMappingURL=ProductsSelectModal.js.mapvar __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { TagsSearchModalContainer, TagsSearchModalWrapper, ProductTagsSearchTitle, CardsWrapper, CardsEmptyTitle, CardsEmptySubTitle, CardsEmptyButtonWrapper, CardsEmptyButtonHollow, CardsEmptyButtonFilled, ModalButton, ModalText, RingWrapper, SelectRing } from './styles';
import urlApi from '../../../actions/urlApi';
import { API } from '@brg/api';
import queryString from 'query-string';
import { useProfile } from '@brg/auth';
import LangContext from '../../../contexts/Language/LangContext';
import { modalControllerActions } from '../../../core/modules/modal.module';
import { useDispatch } from 'react-redux';
import { getGalllleryUrl } from '../../../actions/getGalllleryUrl';
import { ShopCard } from '../../ShopCard/ShopCard';
import { Colors, FlexBox } from '@brg/ui';
import AspectRatio from '../../AspectRatio';
import useLocalization from '../../../hooks/useLocalization';
import { ProjectSearchBarSorting } from '../../projectsSearchBar/components/projectSearchBarSorting';
import { Pagination } from "../../pagination";
import { NoProjectWrapper } from "../CardSelectModal/styles";
export var debounceEvent = function (callback, time) {
    var interval;
    // @ts-ignore
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(interval);
        interval = setTimeout(function () {
            interval = null;
            // eslint-disable-next-line standard/no-callback-literal
            callback.apply(void 0, args);
        }, time);
    };
};
export var useProductsCards = function (queryString, disabled) {
    var _a = useState(null), data = _a[0], setData = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    useEffect(function () {
        if (queryString && !disabled) {
            setLoading(true);
            urlApi()
                .getUserProducts(queryString)
                .then(function (r) {
                setData(r);
            })
                .finally(function () { return setLoading(false); });
        }
    }, [queryString, disabled]);
    return { data: data, loading: loading };
};
var ProductsSelectModal = function (_a) {
    var _b, _c, _d, _e;
    var onSubmit = _a.onSubmit, cardIds = _a.cardIds, teamId = _a.teamId;
    var language = useLocalization().language;
    var cardsRef = useRef(null);
    var _f = useState(cardIds), selectedCards = _f[0], setSelectedCards = _f[1];
    var _g = useState(1), sorting = _g[0], setSorting = _g[1];
    var profile = useProfile();
    var dispatch = useDispatch();
    // @ts-ignore
    var t = useContext(LangContext).t;
    var buttonDisabled = !(selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) || (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) > 4;
    var _h = useState(1), currentPage = _h[0], setPage = _h[1];
    var scrollRef = useRef(null);
    var scrollTop = function () {
        var _a;
        if (!scrollRef.current)
            return;
        (_a = scrollRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo(0, 0);
    };
    var onClick = useCallback(function (cardId, selected) {
        if (selected) {
            setSelectedCards(selectedCards.filter(function (item) { return item !== cardId; }));
            return;
        }
        setSelectedCards(__spreadArray(__spreadArray([], selectedCards, true), [cardId], false));
    }, [selectedCards]);
    var cardsQueryString = useMemo(function () {
        // @ts-ignore
        return queryString.stringify({
            cardOnlyImage: true,
            status: [2],
            userIds: (profile && !teamId) ? [profile === null || profile === void 0 ? void 0 : profile.accountId] : [],
            teamId: teamId,
            isHeaderIgnored: true,
            isLite: 'true',
            sort: sorting,
            page: currentPage,
            limit: 16
        });
    }, [sorting, teamId, profile, currentPage]);
    var _j = useProductsCards(cardsQueryString), data = _j.data, loading = _j.loading;
    // @ts-ignore
    var cards = API.lang(data === null || data === void 0 ? void 0 : data.data, language);
    var handleAttachClick = function () {
        if (!buttonDisabled) {
            onSubmit(selectedCards);
        }
    };
    if (!loading && (cards === null || cards === void 0 ? void 0 : cards.length) === 0)
        return (React.createElement(TagsSearchModalWrapper, { scroll: true, isWhite: true },
            React.createElement(TagsSearchModalContainer, { isCenterModal: true },
                React.createElement(CardsEmptyTitle, null, t('modal.select_card_modal.no_cards')),
                React.createElement(CardsEmptySubTitle, null, t('modal.select_card_modal.no_cards_desc')),
                React.createElement(CardsEmptyButtonWrapper, null,
                    React.createElement(CardsEmptyButtonHollow, { onClick: function () { return dispatch(modalControllerActions.hideModal({})); } }, t('modal.select_card_modal.continue_edit')),
                    React.createElement(CardsEmptyButtonFilled, { onClick: function () { return window.open(getGalllleryUrl(), '_blank'); } }, t('modal.select_card_modal.go_to_gallllery'))))));
    return (React.createElement(TagsSearchModalWrapper, { autoScroll: true },
        React.createElement(TagsSearchModalContainer, null,
            React.createElement(FlexBox, { justify: 'space-between', align: 'center', offsetBottom: 48 },
                React.createElement(ProductTagsSearchTitle, null, t('modal.select_card_modal.select_cards')),
                React.createElement(ModalButton, { onClick: handleAttachClick, fill: Colors.galBlack100, disabled: buttonDisabled }, t('modal.select_card_modal.attach'))),
            React.createElement(FlexBox, { justify: 'space-between', offsetBottom: 32 },
                React.createElement(FlexBox, { align: 'center', gx: 24 },
                    React.createElement(ModalText, null, t('modal.select_card_modal.cards')),
                    React.createElement(ModalText, { color: Colors.galBlack47 },
                        t('modal.select_card_modal.selected_cards'),
                        ":",
                        ' ',
                        (selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length) > 4 ? (React.createElement("span", { style: { color: 'red' } }, selectedCards === null || selectedCards === void 0 ? void 0 :
                            selectedCards.length,
                            "/4")) : (React.createElement("span", null, selectedCards === null || selectedCards === void 0 ? void 0 : selectedCards.length)))),
                React.createElement(ProjectSearchBarSorting, { selectedSorting: sorting, onSortingChange: setSorting, sortingMethods: [1, 2] })),
            (cards === null || cards === void 0 ? void 0 : cards.length) > 0 ? (React.createElement(React.Fragment, null,
                React.createElement(CardsWrapper, { ref: cardsRef }, !!data &&
                    (
                    /* @ts-ignore */
                    cards === null || cards === void 0 ? void 0 : cards.map(function (value) {
                        var selected = selectedCards.includes(value === null || value === void 0 ? void 0 : value.entityId);
                        return (
                        // @ts-ignore
                        React.createElement(AspectRatio, { key: value === null || value === void 0 ? void 0 : value.entityId, ratio: 111 / 148 },
                            React.createElement(ShopCard, { useTemplateCard: true, isSmall: true, isModal: true, customClick: function () { return onClick(value === null || value === void 0 ? void 0 : value.entityId, selected); }, selected: selected, key: value === null || value === void 0 ? void 0 : value.entityId, card: value, hideDescription: true, selectedComponent: React.createElement(RingWrapper, { className: 'selected-component', onClick: function () { return onClick(value === null || value === void 0 ? void 0 : value.entityId, selected); } },
                                    React.createElement(SelectRing, { active: selected }, selected && (React.createElement("div", null,
                                        React.createElement("svg", { width: "12", height: "10", viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                                            React.createElement("path", { d: "M1 4.85653L4.62216 8.45739L11.2699 1.83097L10.4389 1L4.62216 6.79545L1.80966\n                                                  4.02557L1 4.85653Z", fill: "#151514", stroke: "#151514" })))))) })));
                    }))),
                React.createElement("div", { style: { marginTop: 50 } },
                    React.createElement(Pagination
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        pages: (_c = (_b = data === null || data === void 0 ? void 0 : data.paging) === null || _b === void 0 ? void 0 : _b.pages) !== null && _c !== void 0 ? _c : 0, page: Number(currentPage), onPageChange: function (page) {
                            // @ts-ignore
                            setPage(page);
                            scrollTop();
                        }, 
                        // @ts-ignore
                        isCanLoadMore: currentPage < ((_e = (_d = data === null || data === void 0 ? void 0 : data.paging) === null || _d === void 0 ? void 0 : _d.pages) !== null && _e !== void 0 ? _e : 0) })))) : (React.createElement(NoProjectWrapper, null, "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E :(")))));
};
export default ProductsSelectModal;
//# sourceMappingURL=ProductsSelectModal.js.map